
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class StarClustersEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const clusterCount = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let c = 0; c < clusterCount; c++) {
                const cx = (this.pseudoRandom(c) - 0.5) * width * 2;
                const cy = (this.pseudoRandom(c + 10) - 0.5) * height * 2;
                
                const starCount = 50;
                for (let i = 0; i < starCount; i++) {
                    const angle = this.pseudoRandom(c + i) * Math.PI * 2;
                    const dist = Math.pow(this.pseudoRandom(c + i + 100), 2) * 200 * scale;
                    const px = cx + Math.cos(angle) * dist;
                    const py = cy + Math.sin(angle) * dist;
                    
                    const size = (1 + this.pseudoRandom(c + i + 200) * 2) * scale;
                    const twinkle = (Math.sin(time * 2 + c + i) + 1) * 0.5;
                    
                    ctx.save();
                    ctx.globalAlpha = twinkle / (layerIndex + 1);
                    ctx.beginPath();
                    ctx.arc(px, py, size, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
